export default "__VITE_ASSET__gB11ookW__"